@if (view === 'list') {
  <div class="outgoing-data">
    <div class="flex items-center justify-between">
      <h3 class="m-0">{{ sectionTitle }}</h3>
      <button blazeIconButton blazeIconButtonSize="lg" (click)="addOutputParameter()">
        <mat-icon svgIcon="icon_add_24" />
      </button>
    </div>
    <div class="outgoing-parameters">
      @for (row of rows(); track row.uid) {
        <blaze-openai-connector-output-parameters
          view="parameter"
          [property]="row.property"
          (removeParameter)="removeRow(row.uid)"
          (parameterValueChanged)="updateRow(row.uid, $event)"
          (isValid)="updateRowValidity(row.uid, $event)"
        />
      }
    </div>
  </div>
} @else if (view === 'parameter') {
  @let isWrapped = paramWrapped();
  @let dataType = propertyForm.get('dataType')?.value || '';
  <div class="outgoing-parameters-section" [formGroup]="propertyForm">
    <div class="outgoing-parameter header">
      <div class="form-control mr-[50px]">
        <label class="required">Name</label>
        <input
          #outputParameterNameInput
          type="text"
          formControlName="name"
          name="name"
          class="bd-text-input tall w-full"
          required
        />
      </div>
      <div class="form-control">
        <label class="required !min-w-min mr-10">Type</label>
        <blaze-select
          class="select-input tall w-full"
          formControlName="dataType"
          name="dataType"
          [options]="outputDataTypeOptions"
          [showSelection]="true"
          [allowNone]="false"
          [showNoneOption]="false"
          [required]="true"
        />
      </div>
      <div class="actions">
        <button blazeIconButton blazeIconButtonSize="lg" (click)="removeOutputParameter()">
          <mat-icon svgIcon="icon_trash_16" />
        </button>
        <button
          blazeIconButton
          blazeIconButtonSize="lg"
          [blazeIconButtonActive]="!isWrapped"
          (click)="wrapToggle()"
        >
          <mat-icon [class.rotate-180]="isWrapped" svgIcon="icon_chevron_up_16" />
        </button>
      </div>
    </div>
    @if (!isWrapped) {
      @let descriptionPlaceholder = outgoingDescription[dataType];
      <div class="form-control">
        <label>Description</label>
        <textarea
          formControlName="description"
          name="description"
          class="bd-text-input w-full !h-40 !pt-10"
          rows="1"
          [placeholder]="descriptionPlaceholder || ''"
        ></textarea>
      </div>
      @if (dataType === 'String') {
        <div class="form-control">
          <label>Pattern</label>
          <input
            type="text"
            formControlName="pattern"
            name="pattern"
            class="bd-text-input tall w-full"
          />
        </div>
      }
      @let isNumberType =
        dataType === 'Int' ||
        dataType === 'Long' ||
        dataType === 'Double' ||
        dataType === 'Decimal';
      @if (isNumberType) {
        <div class="flex gap-[60px] self-start">
          <div class="form-control">
            <label>Max #</label>
            <input
              type="text"
              formControlName="max"
              name="max"
              class="bd-text-input tall w-[90px]"
              required
            />
          </div>
          <div class="form-control gap-16">
            <label class="!min-w-min mr-10">Min #</label>
            <input
              type="text"
              formControlName="min"
              name="min"
              class="bd-text-input tall w-[90px]"
              required
            />
          </div>
        </div>
      }
      @if (dataType === 'Enum') {
        <div class="form-control">
          <label>Options</label>
          <input
            type="text"
            formControlName="enums"
            name="enums"
            placeholder="Comma separated values"
            class="bd-text-input tall w-full"
            required
          />
        </div>
      }
      <div class="gap-30">
        <mat-slide-toggle disableRipple class="bd-toggle" formControlName="isOptional">
          Optional
        </mat-slide-toggle>
        <div class="flex flex-1 items-baseline gap-30 flex-wrap">
          <mat-slide-toggle
            disableRipple
            class="bd-toggle pt-0 text-primary-darker"
            formControlName="multipleValues"
          >
            Multiple Values
          </mat-slide-toggle>

          @let multipleValues = propertyForm.get('multipleValues')?.value;
          @if (multipleValues) {
            <div class="flex gap-30 self-start flex-wrap">
              <div class="form-control">
                <label>Max # of Items</label>
                <input
                  type="text"
                  formControlName="maxLength"
                  name="maxLength"
                  class="bd-text-input tall w-[90px]"
                  required
                />
              </div>
              <div class="form-control">
                <label>Min # of Items</label>
                <input
                  type="text"
                  formControlName="minLength"
                  name="minLength"
                  class="bd-text-input tall w-[90px]"
                  required
                />
              </div>
            </div>
          }
        </div>
      </div>
      @if (dataType === 'Item') {
        <blaze-openai-connector-output-parameters
          view="list"
          sectionTitle="Object Properties"
          [properties]="propertyForm.get('properties')?.value || []"
          (valuesChanged)="updateParameters($event)"
          (isValid)="isChildValid.set($event)"
        />
        @if (propertyForm.hasError('itemProperties')) {
          <span class="text-warn">Add at least one property to save this object.</span>
        }
      }
    }
  </div>
}
